import { useEffect } from 'react'
import format from 'date-fns/format'
import Link from 'next/link'
import { Type } from '@/components/common'
import SegmentHandler from '@/services/analytics/SegmentHandler'
import fbPixel, { getCampaignPixels } from '@/services/analytics/fbPixel'
import { Campaign } from '@/services/api/campaign'

export interface Props {
  campaign: Campaign
}

const DisabledCampaignPage: React.FC<Props> = ({ campaign }) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer.push({
        event: 'landing-page',
        campaign: campaign.name,
        status: campaign.regulationType,
      })
    }
  }, [campaign])

  useEffect(() => {
    if (campaign) {
      fbPixel.init(getCampaignPixels(campaign))
      fbPixel.pageView()
      SegmentHandler.track(
        'Campaign Pageview',
        { campaign: campaign.name, project: campaign.slug },
        { suppressSegmentTrack: true }
      )
    }
  }, [campaign])

  return (
    <div className="flex items-center justify-center py-12 md:py-24 px-4">
      <div className="text-center p-6 rounded-lg bg-white border border-core-gray-200 max-w-lg">
        <div className="flex items-center justify-center">
          <Type as="h1" variant="heading-sm" className="text-pretty">
            This offering is no longer active.
          </Type>
        </div>
        <Type
          as="p"
          variant="paragraph-md"
          className="text-core-gray-700 mt-4 text-balance"
        >
          This offering ended on{' '}
          {format(new Date(campaign.closeDate), 'MMM d, yyyy')}.{' '}
          <Link href="/investments" className="underline">
            Click here
          </Link>{' '}
          to view your investments.
        </Type>
      </div>
    </div>
  )
}

export default DisabledCampaignPage
